module.exports = __webpack_public_path__ + "img/border_RightArrow2.58f48720.svg";